<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM21.1 16.2688C21.6143 16.2688 22 14.5813 22 12.5C22 10.4187 21.6143 8.73125 21.1 8.73125C20.5857 8.73125 20.2 10.4187 20.2 12.5C20.2 14.5813 20.5857 16.2688 21.1 16.2688ZM17.2429 16.7188C18.5929 16.7188 19.75 14.8062 19.75 12.5C19.75 10.1938 18.5929 8.28125 17.2429 8.28125C15.8929 8.28125 14.7357 10.1938 14.7357 12.5C14.7357 14.8062 15.8929 16.7188 17.2429 16.7188ZM9.07857 17C11.9071 17 14.1571 14.975 14.1571 12.5C14.1571 10.025 11.9071 8 9.07857 8C6.25 8 4 10.025 4 12.5C4 14.975 6.25 17 9.07857 17Z" 
        fill="currentColor"
    />
    </svg>
</template>